import { useCallback, useState } from "react";

import type {
	InvoiceFilter,
	PaymentNonce,
	SavedAch,
	SavedCard,
} from "~/shared/types/payment-types.ts";

import type { InvoiceStatus } from "./use-invoice-selection.ts";

export function usePaymentState() {
	const [currentStatus, setCurrentStatus] =
		useState<InvoiceStatus>("openInvoices");
	const [currentFilter, setCurrentFilter] = useState<InvoiceFilter | null>(
		null,
	);
	const [selectedPaymentValue, setSelectedPaymentValue] = useState<
		SavedCard | SavedAch | PaymentNonce | null
	>(null);

	const handleStatusChange = useCallback((status: InvoiceStatus) => {
		setCurrentStatus(status);
		setCurrentFilter(null);
	}, []);

	const handleFilterChange = useCallback((filter: InvoiceFilter) => {
		setCurrentFilter(filter);
		setCurrentStatus("openInvoices");
	}, []);

	const handleApplyPaymentMethod = useCallback(
		(paymentMethod: SavedCard | SavedAch | PaymentNonce | null) => {
			setSelectedPaymentValue(paymentMethod);
		},
		[],
	);

	const resetPaymentValue = useCallback(() => {
		setSelectedPaymentValue(null);
	}, []);

	return {
		currentStatus,
		currentFilter,
		selectedPaymentValue,
		setSelectedPaymentValue,
		handleStatusChange,
		handleFilterChange,
		handleApplyPaymentMethod,
		resetPaymentValue,
	};
}
